import { useSelector } from 'react-redux';
import { selectEnableTournamentService } from '~/components/brand/ducks/selectors';
import { gameCodesSelector } from '~/components/casino-shared/tournaments/ducks/selectors';

const useIsTournamentRankAvailable = (gameCode: string | undefined) => {
	const isTournamentServiceEnabled = useSelector(selectEnableTournamentService);
	const gameCodes = useSelector(gameCodesSelector);

	if (!isTournamentServiceEnabled || !gameCode) {
		return false;
	}

	return gameCodes.includes(gameCode);
};

export default useIsTournamentRankAvailable;
